import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import ISelectAPIComponent from '@components/FormFlow/Interfaces/FormflowComponents/ISelectAPIComponent';
import ISelectOption from '@components/FormFlow/Interfaces/FormflowComponents/Util/ISelectOption';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentType } from '@interfaces/component-type';
import { Pillar } from '@interfaces/pillar';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, Col, Icon, Input, Row, Select, Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { InstructionTaskComponent } from '../TextInstructionComponent';

const Option = Select.Option;

let isValidate: any = []

interface ISelectTaskComponentStateType {
  instructionTitle: string;
  required: boolean;
  description?: string;
  newOrExistingItemList?: any;
  conditionsTaskComponents: boolean;
  multiple: boolean;
  minMultiple: number;
  maxMultiple: number;
  pillar: Pillar;
  entityAPI: string;
  options: ISelectOption[];
  isValidate: boolean;
  speech: boolean;
};
export class SelectComponent implements ISelectAPIComponent {
  id: string;
  required: boolean;
  type: ComponentType;
  title: string;
  description?: string;
  multiple: boolean;
  speech: boolean;
  minMultiple: number;
  maxMultiple: number;
  pillar: Pillar;
  entityAPI: string | undefined;
  options: ISelectOption[];
  constructor(id: string = '') {
    this.id = id;
    this.required = false;
    this.type = ComponentType.SELECT;
    this.title = '';
    this.multiple = false;
    this.minMultiple = 0;
    this.maxMultiple = 0;
    this.pillar = Pillar.EHSS;
    this.entityAPI = undefined;
    this.options = [];
    this.speech = false;
    return this;
  }
}
export default class SelectTaskComponent extends React.Component<ISelectAPIComponent, ISelectTaskComponentStateType> {
  constructor(props: ISelectAPIComponent) {
    super(props);
    this.state = {
      instructionTitle: '',
      description: this.props.description || undefined,
      required: this.props.required || false,
      multiple: this.props.multiple || false,
      minMultiple: this.props.minMultiple,
      maxMultiple: this.props.maxMultiple,
      entityAPI: this.props.entityAPI || '',
      pillar: this.props.pillar,
      newOrExistingItemList: this.props.type, //FIXME: não deixar esse valor como inicial
      conditionsTaskComponents: true,
      options: this.props.options,
      isValidate: false,
      speech: this.props.speech || false
    };
  }

  componentDidMount() {
    this.setState({ instructionTitle: this.props.title })

    if (this.props.options.length === 0) {
      this.setState({ options: [{ value: '', weight: undefined }] })
    }
  }

  handleIntructionTitleChange = async (evt: any) => {
    this.setState({ instructionTitle: evt.target.value });
  }
  handleDescriptionChange = async (evt: any) => {
    this.setState({ description: evt.target.value });
  }
  handleRequiredChange = async (evt: any) => {
    this.setState({ required: evt.target.checked });
  }
  handleMultipleChange = async (evt: any) => {
    this.setState({ multiple: evt.target.value });
    console.log('ABC', this.state.multiple)
  }
  handleSelectAPIChange = async (evt: any) => {
    this.setState({ entityAPI: evt });
  }
  onChangeRadioNewOrExistingList = async (evt: any) => {
    this.setState({ newOrExistingItemList: evt.target.value })
    if (this.state.newOrExistingItemList === ComponentType.SELECT)
      this.setState({ conditionsTaskComponents: true })
    else if (this.state.newOrExistingItemList === ComponentType.SELECTAPI)
      this.setState({ conditionsTaskComponents: false })
  }
  handleInputItemChange = (idx: any) => (evt: any) => {
    const newSelectList = this.state.options.map((selectListItems, sidx) => {
      if (idx !== sidx) return selectListItems;
      return { ...selectListItems, value: evt.target.value };
    });

    this.setState({ options: newSelectList });
    console.log('valor do input', this.state.options)
  }
  handleInputScoreChange = (idx: any) => (evt: any) => {
    const newSelectListScore = this.state.options.map((selectListScore, sidx) => {
      if (idx !== sidx) return selectListScore;
      return { ...selectListScore, weight: evt.target.value };
    });
    console.log('weight', evt)
    this.setState({ options: newSelectListScore });
  }
  handleAddNewSelectList = async () => {
    this.setState({
      options: this.state.options.concat([{ value: '', weight: undefined }]),
    });
  }
  handleRemoveSelectList = (index: number) => async () => {
    this.setState({
      options: this.state.options.filter((section: any, sindex: number) => index !== sindex),
    });
  }

  handleSpeechChange = async (evt: any) => {
    this.setState({ speech: evt.target.checked });
  }

  onSubmiSelectComponent(updateFormflowWithComponent: (component: IBaseComponent) => void) {
    if (this.state.newOrExistingItemList === ComponentType.SELECT) {
      const newTextDataComponent: ISelectAPIComponent = {
        id: this.props.id,
        type: ComponentType.SELECT,
        title: this.state.instructionTitle,
        description: this.state.description,
        required: this.state.required,
        multiple: this.state.multiple,
        minMultiple: this.state.minMultiple,
        maxMultiple: this.state.maxMultiple,
        options: this.state.options,
        entityAPI: this.state.entityAPI,
        pillar: this.state.pillar,
        speech: this.state.speech
      }
      updateFormflowWithComponent(newTextDataComponent);
    }
    if (this.state.newOrExistingItemList === ComponentType.SELECTAPI) {
      const newTextDataComponent: ISelectAPIComponent = {
        id: this.props.id,
        type: ComponentType.SELECTAPI,
        title: this.state.instructionTitle,
        description: this.state.description,
        required: this.state.required,
        multiple: this.state.multiple,
        minMultiple: this.state.minMultiple,
        maxMultiple: this.state.maxMultiple,
        options: this.state.options,
        entityAPI: this.state.entityAPI,
        pillar: this.state.pillar,
        speech: false
      }
      updateFormflowWithComponent(newTextDataComponent);
    }
  }
  isDisabled = async () => {
    for (let itemsValidete of this.state.options) {
      if (itemsValidete.value === '') {
        isValidate.push(false)
        // this.setState({isValidate: false})
      }
      else {
        isValidate = []

        // this.setState({isValidate: true})
      }
    }
    console.log("valor do validate", isValidate.length)
  }

  validationSelects(items: any) {
    this.isDisabled()
    let fieldIsRequired: JSX.Element = <div />;
    if (items.value === '') {
      fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("form.validation.field.required")}</span>)
    }
    return fieldIsRequired;
  }

  render() {
    const {
      newOrExistingItemList,
      conditionsTaskComponents,
      instructionTitle,

    } = this.state;
    const {
      required
    } = this.props;
    return (
      <Wrapper>
        <InstructionTaskComponent
          visibleDescription={false}
          inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
          ItemList={newOrExistingItemList}
          radioListNewOrExisting={true}
          inputTitleValue={instructionTitle}
          requiredCheckedValue={required}
          speech={this.props.speech}
          valueRadioSelect={newOrExistingItemList}
          onInputInstructionChange={() => this.handleIntructionTitleChange}
          onChangeDescription={() => this.handleDescriptionChange}
          onChangeRequiredCheckbox={() => this.handleRequiredChange}
          onChangeSpeech={this.handleSpeechChange}
          titleComponent={I18n.l("formflow.components.selectComponent.titleDateComponent")}
          descriptionComponent={I18n.l("formflow.components.selectComponent.descriptionListComponent")}
          exampleDescriptionComponent={I18n.l("formflow.components.selectComponent.exampleDescriptionListComponent")}
          radioOnlyOneOrMultipleItemList={true}
          titleRadioOnlyOneItemList={I18n.l("formflow.components.selectComponent.titleRadioOnlyOneItemList")}
          titleRadioMultipleItemList={I18n.l("formflow.components.selectComponent.titleRadioMultipleItemList")}
          onChangeRadioNewOrExistingList={this.onChangeRadioNewOrExistingList}
          conditionsTaskComponents={conditionsTaskComponents}
          valueRadioItemList={this.state.multiple}
          onChangeRadioMultipleItemList={this.handleMultipleChange}
        />
        {(newOrExistingItemList === ComponentType.SELECT) &&
          <div>
            <DividerBorder />
            <Row style={{ width: '50%' }} >
              {this.state.options.map((list: any, idx: number) => (
                <div key={idx}>
                  <Col sm={14} md={14} xl={14}>
                    <div className="input-item-style">
                      <p>{I18n.l("formflow.components.selectComponent.itemList")}</p>
                      <Input
                        defaultValue={list.value}
                        style={list.value === '' ? { borderColor: `${Theme.secondary.red}` } : {}}
                        className={list.value.length === 150 ? "apply-shake" : ''}
                        maxLength={150}
                        value={list.value}
                        onChange={this.handleInputItemChange(idx)}
                      />
                      {this.validationSelects(list)}
                      <p style={{ float: 'right' }} className={list.value.length < 150 ? "count-input" : "count-input-red"} >
                        {list.value.length !== 0 ? list.value.length + ' / 150' : '0 / 150'}
                      </p>
                    </div>
                  </Col>
                  <Col sm={10} md={10} xl={10}>
                    <div className="input-score-style">
                      <p>{I18n.l("formflow.components.selectComponent.scoreList")}
                        <Tooltip placement="right" title={I18n.l("formflow.components.selectComponent.scoreTooltipHelp")}>
                          <FontAwesomeIcon style={{ marginLeft: '10px', color: `${Theme.secondary.midGrey}` }} icon={'question'} />
                        </Tooltip></p>
                      <Input
                        style={{ width: '50%' }}
                        defaultValue={list.weight}
                        onChange={this.handleInputScoreChange(idx)}
                      />
                      <Icon
                        style={{ color: 'red', marginLeft: '10px', cursor: "pointer" }}
                        type="close"
                        // disabled={x.lenght === 1}
                        onClick={this.handleRemoveSelectList(idx)}
                      />
                    </div>
                  </Col>
                </div>
              ))}
            </Row>
            <ButtonStyle>
              <Button onClick={this.handleAddNewSelectList} className="goepik-btn-border-main">
                <Icon type="plus" /> {I18n.l("formflow.buttons.createNewItemSepectComponent").toUpperCase()}
              </Button>
            </ButtonStyle>
          </div>
        }
        {(newOrExistingItemList === ComponentType.SELECTAPI) &&
          <div>
            <DividerBorder />
            <div className="input-item-style" >
              <p>{I18n.l("formflow.components.selectAPIComponent.titleShowingListSelectAPI")}</p>
              <Select onChange={this.handleSelectAPIChange} defaultValue={this.props.entityAPI} placeholder={I18n.l("formflow.components.selectAPIComponent.selectAPIPlaceHolder")} style={{ width: '30%' }}>
                <Option value="assignment">{I18n.l("formflow.components.selectAPIComponent.selectAPIAssignment")}</Option>
              </Select>
            </div>
          </div>
        }
        <FormflowContext.Consumer>
          {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
            <div>
              <ButtonSaveStyle>
                <Row type="flex" justify="end">
                  <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                  <Button
                    className="button-save" type="primary"
                    disabled={instructionTitle.length === 0 ||
                      instructionTitle.length < 3 ||
                      this.state.newOrExistingItemList === ComponentType.SELECTAPI && this.state.entityAPI === '' ||
                      this.state.newOrExistingItemList === ComponentType.SELECT && isValidate.length !== 0
                      ?
                       true : false}
                    onClick={() => { this.onSubmiSelectComponent(updateFormflowWithComponent) }} >
                    {I18n.l('common.save')}
                  </Button>
                </Row>
              </ButtonSaveStyle>
            </div>
          )}
        </FormflowContext.Consumer>
      </Wrapper>
    );
  }
}
const Wrapper = styled.div`
    width:100%;
    margin-bottom: 10rem;
    .optional-validation-condition-text{
        font-weight: bold;
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .text-checkbox-validation{
        width:50%;
        margin-top: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .text-input-validation{
        width: 70px;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
    }
    .input-item-style{
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 80%;
    }
    .input-score-style{
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 100%;
    }
    .delete-style{
        margin-top: 2rem;
    }
    .count-input{
        margin-top:2px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .count-input-red{
        margin-top:2px;
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
          transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
          transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
          transform: translate3d(4px, 0, 0);
        }
      }
      .apply-shake {
          animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      }
`
const DividerBorder = styled.div`
    margin-top: 2rem;
    margin-left: 3rem;
    margin-right: 3rem;   
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`
const ButtonStyle = styled.div`
    margin-left: 3rem;
    margin-right: 3rem;   
`
const ButtonSaveStyle = styled.div`
    float:right;
    margin-top: 5vh;
    margin-bottom: 5vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`;